import { ExtendedAreaModels } from '@bpd-library/utilities';
import { FILTER_NAMES } from '@features/properties/components/property-filter';
import { hasFilterUrl } from '@source/utilities/filters/urls';
import { translateItem } from '@source/utilities/hooks';

import { Filters } from './construct-filters';

export const setProjectPhasesFilters = async (data: ExtendedAreaModels, filters: Filters) => {
    // Project phases without any property types and construction numbers should not be in the filter.
    const filteredProjectPhases = data.projectPhases.filter(
        ({ constructionNumbers, propertyTypes }) =>
            constructionNumbers?.length || propertyTypes?.length,
    );

    const hasProjectPhases = filteredProjectPhases.length > 1;

    if (hasProjectPhases) {
        const filterName = FILTER_NAMES.projectPhases;

        filters[filterName] = {
            expanded: false,
            icon: 'specs-floors',
            title: await translateItem('Filters.ProjectPhase.label'),
            dropdownLabel: await translateItem('Filters.ProjectPhase.dropdownLabel'),
            filterFunctions: {
                constructionNumber: (constructionNumber, filterInput) =>
                    constructionNumber.projectPhaseId === filterInput.value,
                propertyType: (propertyType, filterInput) =>
                    propertyType.projectPhaseId === filterInput.value,
                projectPhase: (projectPhase, filterInput) => projectPhase.id === filterInput.value,
            },
            filterName,
            hasRangeValues: false,
            filters: {
                type: 'checkbox',
                components: filteredProjectPhases.map((projectPhase) => ({
                    id: `${filterName}-${projectPhase.name}`,
                    label: `${projectPhase.name}`,
                    value: `${projectPhase.id}`,
                    name: filterName,
                    checked: hasFilterUrl(`${projectPhase.id}`, filterName),
                    type: 'checkbox',
                })),
            },
        };
    }
};
